import {useAppSelector} from '@/hooks';

export const useGetCurrentPageNumber = (): number => {
  const pageOrder = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages.pageOrder;
  });
  const currentPageId = useAppSelector((state) => {
    return state.posterEditor.currentPageId;
  });

  if (!pageOrder || !currentPageId) {
    return 1;
  }

  return pageOrder.indexOf(currentPageId) + 1;
};
